import MainLayout from 'Layout/MainLayout'
import React from 'react'
import LandingHeader from 'Layout/LandingHeader';
import DetailDesaCerdas from 'Layout/DetailDesaCerdas';
import Step from 'Layout/Step';

export default function LandingPage() {
  return (
    <MainLayout active="beranda">
      <LandingHeader />
      <DetailDesaCerdas />
      <Step/>
    </MainLayout>
  );
}
